import { post, get } from '../axios'

// 查询服装配置码值列表
export function config_list_category_size_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-category-size`,
    map,
    option
  ).then(response => response)
}

// 系统配置列表查询
export function config_list_config_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config`,
    map,
    option
  ).then(response => response)
}

// 流程节点天数配置查询
export function config_list_config_flow_days_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-flow-days`,
    map,
    option
  ).then(response => response)
}

// 报表流程节点天数
export function config_list_config_flow_days_report_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-flow-days-report`,
    map,
    option
  ).then(response => response)
}

// 工作台权限配置列表
export function config_list_config_permissions_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-permissions`,
    map,
    option
  ).then(response => response)
}

// 产品品类对应价格占比配置表查询
export function config_list_config_product_price_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-product-price`,
    map,
    option
  ).then(response => response)
}

// 系统配置列表查询
export function config_list_config_size_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-size`,
    map,
    option
  ).then(response => response)
}

// 设计师、版师、工艺员对应关系配置查询
export function config_list_config_staff_match_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-staff-match`,
    map,
    option
  ).then(response => response)
}

// 查询流程配置
export function config_list_process_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-process`,
    map,
    option
  ).then(response => response)
}

// 查询产品分类
export function config_list_product_category_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-product-category`,
    map,
    option
  ).then(response => response)
}

// 查询产品分类(精确到二级类目)
export function config_list_product_second_category_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-product-second-category`,
    map,
    option
  ).then(response => response)
}

// 员工查询信息
export function config_list_staff_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-staff`,
    map,
    option
  ).then(response => response)
}

// 员工查询信息
export function config_list_staff_all_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-staff-all`,
    map,
    option
  ).then(response => response)
}

// 查询用户权限
export function config_query_config_permissions_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/query-config-permissions`,
    map,
    option
  ).then(response => response)
}

// 提交利润率配置
export function config_submit_config_benefit_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/submit-config-benefit`,
    map,
    option
  ).then(response => response)
}

// 提交供应商仓库映射配置
export function config_submit_config_warehouse_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/submit-config-warehouse`,
    map,
    option
  ).then(response => response)
}

// 更新流程节点天数配置
export function config_update_config_flow_day_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/update-config-flow-day`,
    map,
    option
  ).then(response => response)
}

// 更新工作台配置
export function config_update_config_permissions_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/update-config-permissions`,
    map,
    option
  ).then(response => response)
}

// 提交易仓供应商配置表
export function config_submit_config_supplier_info_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/submit-config-supplier-info`,
    map,
    option
  ).then(response => response)
}

// 员工所有信息
export function config_staff_post(map, option) {
  return post(`${process.env.VUE_APP_CONFIG}/config/staff`, map, option).then(
    response => response
  )
}

// 供应商类型
export function config_get_supplier_type_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/get-supplier-type`,
    map,
    option
  ).then(response => response)
}

// 新增timeline流程类目关系配置
export function config_timeline_add_work_bench_relation_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/timeline/add-work-bench-relation`,
    map,
    option
  ).then(response => response)
}

// 删除timeline流程类目关系配置
export function config_timeline_delete_work_bench_relation_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/timeline/delete-work-bench-relation`,
    map,
    option
  ).then(response => response)
}

// 查询timeline流程类目关系配置
export function config_timeline_list_work_bench_relation_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/timeline/list-work-bench-relation`,
    map,
    option
  ).then(response => response)
}

// 查询版型库产品分类
export function config_list_product_category_block_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-product-category-block`,
    map,
    option
  ).then(response => response)
}

// 新增业务组设计师配置
export function config_add_business_group_designer_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-business-group-designer`,
    map,
    option
  ).then(response => response)
}

// 报关品类价格新增
export function config_add_category_price_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-category-price`,
    map,
    option
  ).then(response => response)
}

// 新增cp自动取号配置
export function config_add_config_automatic_number_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-config-automatic-number`,
    map,
    option
  ).then(response => response)
}

// 新增业务组配置
export function config_add_config_business_group_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-config-business-group`,
    map,
    option
  ).then(response => response)
}

// 新增设计师配置
export function config_add_config_designer_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-config-designer`,
    map,
    option
  ).then(response => response)
}

// 新增尺码部位配置
export function config_add_config_dimensional_position_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-config-dimensional-position`,
    map,
    option
  ).then(response => response)
}

// 新增流程节点天数配置
export function config_add_config_flow_day_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-config-flow-day`,
    map,
    option
  ).then(response => response)
}

// 新增工作台配置
export function config_add_config_permissions_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-config-permissions`,
    map,
    option
  ).then(response => response)
}

// 新增体型版型配置
export function config_add_config_plate_shape_attr_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-config-plate-shape-attr`,
    map,
    option
  ).then(response => response)
}

// 新增产品品类对应价格占比配置
export function config_add_config_product_price_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-config-product-price`,
    map,
    option
  ).then(response => response)
}

// 编辑二级品类尺码配置
export function config_add_config_product_size_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-config-product-size`,
    map,
    option
  ).then(response => response)
}

// 新增采购员与供应商关联配置
export function config_add_config_purchaser_supplier_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-config-purchaser-supplier`,
    map,
    option
  ).then(response => response)
}

// 新增质检瑕疵配置
export function config_add_config_report_defect_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-config-report-defect`,
    map,
    option
  ).then(response => response)
}

// 新增设计师、版师、工艺员对应关系配置
export function config_add_config_staff_match_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-config-staff-match`,
    map,
    option
  ).then(response => response)
}

// 新增商品亮点关联tag配置
export function config_add_config_tag_ref_product_highlights_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-config-tag-ref-product-highlights`,
    map,
    option
  ).then(response => response)
}

// 新增目标价配置
export function config_add_config_target_price_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-config-target-price`,
    map,
    option
  ).then(response => response)
}

// 新增主题配置
export function config_add_config_theme_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-config-theme`,
    map,
    option
  ).then(response => response)
}

// 新增水洗符号配置
export function config_add_config_water_washing_symbol_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-config-water-washing-symbol`,
    map,
    option
  ).then(response => response)
}

// 期望场次配置 新增
export function config_add_expected_sessions_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-expected-sessions`,
    map,
    option
  ).then(response => response)
}

// 新增节假日配置
export function config_add_holiday_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-holiday`,
    map,
    option
  ).then(response => response)
}

// 核价配置 新增
export function config_add_pricing_supplier_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-pricing-supplier`,
    map,
    option
  ).then(response => response)
}

// 新增流程配置
export function config_add_process_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-process`,
    map,
    option
  ).then(response => response)
}

// 新增流程节点配置
export function config_add_process_node_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-process-node`,
    map,
    option
  ).then(response => response)
}

// 新增流程节点关系
export function config_add_process_node_relation_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-process-node-relation`,
    map,
    option
  ).then(response => response)
}

// 新增流程节点配置
export function config_add_process_node_state_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-process-node-state`,
    map,
    option
  ).then(response => response)
}

// 常备特殊面料 新增
export function config_add_standing_special_material_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-standing-special-material`,
    map,
    option
  ).then(response => response)
}

// 提交供应商支付周期数据
export function config_add_supplier_cycle_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-supplier-cycle`,
    map,
    option
  ).then(response => response)
}

// 同步易快报
export function config_add_to_ekb_code_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-to-ekb-code`,
    map,
    option
  ).then(response => response)
}

// 同步易快报2
export function config_add_to_ekb_code2_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-to-ekb-code2`,
    map,
    option
  ).then(response => response)
}

// 供应商小时工资新增
export function config_add_update_salary_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-update-salary`,
    map,
    option
  ).then(response => response)
}

// 批量更新供应商信息
export function config_batch_update_supplier_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/batch-update-supplier`,
    map,
    option
  ).then(response => response)
}

// 删除流程节点天数配置
export function config_del_config_flow_day_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/del-config-flow-day`,
    map,
    option
  ).then(response => response)
}

// 删除工作台配置
export function config_del_config_permissions_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/del-config-permissions`,
    map,
    option
  ).then(response => response)
}

// 删除产品品类对应价格占比配置
export function config_del_config_product_price_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/del-config-product-price`,
    map,
    option
  ).then(response => response)
}

// 删除采购员与供应商关联配置
export function config_del_config_purchaser_supplier_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/del-config-purchaser-supplier`,
    map,
    option
  ).then(response => response)
}

// 新增设计师、版师、工艺员对应关系配置
export function config_del_config_staff_match_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/del-config-staff-match`,
    map,
    option
  ).then(response => response)
}

// 删除供应商支付周期数据
export function config_del_supplier_cycle_get(map, option) {
  return get(
    `${process.env.VUE_APP_CONFIG}/config/del-supplier-cycle`,
    map,
    option
  ).then(response => response)
}

// 删除cp自动取号配置
export function config_delete_config_automatic_number_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/delete-config-automatic-number`,
    map,
    option
  ).then(response => response)
}

// 删除尺码部位配置
export function config_delete_config_dimensional_position_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/delete-config-dimensional-position`,
    map,
    option
  ).then(response => response)
}

// 删除目标价配置
export function config_delete_config_target_price_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/delete-config-target-price`,
    map,
    option
  ).then(response => response)
}

// 核价配置 删除
export function config_delete_pricing_supplier_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/delete-pricing-supplier`,
    map,
    option
  ).then(response => response)
}

// 刪除流程节点配置
export function config_delete_process_node_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/delete-process-node`,
    map,
    option
  ).then(response => response)
}

// 刪除流程节点关系
export function config_delete_process_node_relation_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/delete-process-node-relation`,
    map,
    option
  ).then(response => response)
}

// 刪除流程节点配置
export function config_delete_process_node_state_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/delete-process-node-state`,
    map,
    option
  ).then(response => response)
}

// 常备特殊面料 删除
export function config_delete_standing_special_material_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/delete-standing-special-material`,
    map,
    option
  ).then(response => response)
}

// 报关品类价格详情
export function config_detail_category_price_get(map, option) {
  return get(
    `${process.env.VUE_APP_CONFIG}/config/detail-category-price`,
    map,
    option
  ).then(response => response)
}

// 供应商小时工资详情
export function config_detail_salary_get(map, option) {
  return get(
    `${process.env.VUE_APP_CONFIG}/config/detail-salary`,
    map,
    option
  ).then(response => response)
}

// disableAccount
export function config_disableAccount_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/disableAccount`,
    map,
    option
  ).then(response => response)
}

// 编辑业务组设计师配置
export function config_edit_business_group_designer_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/edit-business-group-designer`,
    map,
    option
  ).then(response => response)
}

// 编辑cp自动取号配置
export function config_edit_config_automatic_number_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/edit-config-automatic-number`,
    map,
    option
  ).then(response => response)
}

// 编辑业务组配置
export function config_edit_config_business_group_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/edit-config-business-group`,
    map,
    option
  ).then(response => response)
}

// 编辑设计师配置
export function config_edit_config_designer_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/edit-config-designer`,
    map,
    option
  ).then(response => response)
}

// 编辑尺码部位配置
export function config_edit_config_dimensional_position_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/edit-config-dimensional-position`,
    map,
    option
  ).then(response => response)
}

// 编辑体型版型配置
export function config_edit_config_plate_shape_attr_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/edit-config-plate-shape-attr`,
    map,
    option
  ).then(response => response)
}

// 编辑质检瑕疵配置
export function config_edit_config_report_defect_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/edit-config-report-defect`,
    map,
    option
  ).then(response => response)
}

// 编辑商品亮点关联tag配置
export function config_edit_config_tag_ref_product_highlights_post(
  map,
  option
) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/edit-config-tag-ref-product-highlights`,
    map,
    option
  ).then(response => response)
}

// 编辑目标价配置
export function config_edit_config_target_price_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/edit-config-target-price`,
    map,
    option
  ).then(response => response)
}

// 编辑主题配置
export function config_edit_config_theme_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/edit-config-theme`,
    map,
    option
  ).then(response => response)
}

// 编辑水洗符号配置
export function config_edit_config_water_washing_symbol_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/edit-config-water-washing-symbol`,
    map,
    option
  ).then(response => response)
}

// enableAccount
export function config_enableAccount_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/enableAccount`,
    map,
    option
  ).then(response => response)
}

// executeSupplierAccountToEkb
export function config_executeSupplierAccountToEkb_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/executeSupplierAccountToEkb`,
    map,
    option
  ).then(response => response)
}

// 供应商列表导出
export function config_export_post(map, option) {
  return post(`${process.env.VUE_APP_CONFIG}/config/export`, map, option).then(
    response => response
  )
}

// 批量上传cp面辅料模板下载
export function config_get_batch_update_supplier_url_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/get-batch-update-supplier-url`,
    map,
    option
  ).then(response => response)
}

// 权限
export function config_get_config_role_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/get-config-role`,
    map,
    option
  ).then(response => response)
}

// 根据sk查询cp
export function config_get_cp_by_skc_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/get-cp-by-skc`,
    map,
    option
  ).then(response => response)
}

// 期望场次配置 列表
export function config_get_expected_sessions_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/get-expected-sessions`,
    map,
    option
  ).then(response => response)
}

// 核价配置 列表
export function config_get_pricing_supplier_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/get-pricing-supplier`,
    map,
    option
  ).then(response => response)
}

// 获取流程节点明细
export function config_get_process_node_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/get-process-node`,
    map,
    option
  ).then(response => response)
}

// 流程节点模板下载url
export function config_get_process_node_url_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/get-process-node-url`,
    map,
    option
  ).then(response => response)
}

// 常备特殊面料 列表
export function config_get_standing_special_material_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/get-standing-special-material`,
    map,
    option
  ).then(response => response)
}

//  供应商账户查询
export function config_get_supplier_account_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/get-supplier-account`,
    map,
    option
  ).then(response => response)
}

// 供应商属性
export function config_get_supplier_attribute_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/get-supplier-attribute`,
    map,
    option
  ).then(response => response)
}

// 供应商类型
export function config_get_supplier_type_get(map, option) {
  return get(
    `${process.env.VUE_APP_CONFIG}/config/get-supplier-type`,
    map,
    option
  ).then(response => response)
}

// 导入价格品类
export function config_importSupplierInfo_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/importSupplierInfo`,
    map,
    option
  ).then(response => response)
}

// 初始化cp-skc
export function config_init_cp_skc_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/init-cp-skc`,
    map,
    option
  ).then(response => response)
}

// 业务组配置查询(枚举下拉使用)
export function config_list_business_group_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-business-group`,
    map,
    option
  ).then(response => response)
}

// 业务组设计师配置查询
export function config_list_business_group_designer_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-business-group-designer`,
    map,
    option
  ).then(response => response)
}

// 报关品类价格列表
export function config_list_category_price_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-category-price`,
    map,
    option
  ).then(response => response)
}

// 报关品类-产品列表
export function config_list_category_product_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-category-product`,
    map,
    option
  ).then(response => response)
}

// 获取动态列值
export function config_list_column_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-column`,
    map,
    option
  ).then(response => response)
}

// cp自动取号配置查询
export function config_list_config_automatic_number_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-automatic-number`,
    map,
    option
  ).then(response => response)
}

// 利润率配置查询
export function config_list_config_benefit_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-benefit`,
    map,
    option
  ).then(response => response)
}

// 业务组配置查询
export function config_list_config_business_group_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-business-group`,
    map,
    option
  ).then(response => response)
}

// 设计师配置查询
export function config_list_config_designer_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-designer`,
    map,
    option
  ).then(response => response)
}

// 查询尺码部位配置
export function config_list_config_dimensional_position_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-dimensional-position`,
    map,
    option
  ).then(response => response)
}

// 体型版型配置查询
export function config_list_config_plate_shape_attr_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-plate-shape-attr`,
    map,
    option
  ).then(response => response)
}

// 采购员与供应商关联配置查询
export function config_list_config_purchaser_supplier_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-purchaser-supplier`,
    map,
    option
  ).then(response => response)
}

// 质检瑕疵配置
export function config_list_config_report_defect_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-report-defect`,
    map,
    option
  ).then(response => response)
}

// 供应商主数据查询
export function config_list_config_supplier_info_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-supplier-info`,
    map,
    option
  ).then(response => response)
}

// 水洗符号与物料编码关联配置查询
export function config_list_config_symbol_ref_material_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-symbol-ref-material`,
    map,
    option
  ).then(response => response)
}

// 商品亮点配置查询
export function config_list_config_tag_ref_product_highlights_post(
  map,
  option
) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-tag-ref-product-highlights`,
    map,
    option
  ).then(response => response)
}

// 目标价配置
export function config_list_config_target_price_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-target-price`,
    map,
    option
  ).then(response => response)
}

// 主题配置查询
export function config_list_config_theme_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-theme`,
    map,
    option
  ).then(response => response)
}

// 供应商仓库映射配置查询
export function config_list_config_warehouse_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-warehouse`,
    map,
    option
  ).then(response => response)
}

// 水洗符号配置查询
export function config_list_config_water_washing_symbol_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-water-washing-symbol`,
    map,
    option
  ).then(response => response)
}

// 节假日查询
export function config_list_holiday_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-holiday`,
    map,
    option
  ).then(response => response)
}

// 物料名称下拉配置查询()
export function config_list_material_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-material`,
    map,
    option
  ).then(response => response)
}

// 物料名称下拉配置查询
export function config_list_material_name_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-material-name`,
    map,
    option
  ).then(response => response)
}

// 获取动态菜单列
export function config_list_menu_field_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-menu-field`,
    map,
    option
  ).then(response => response)
}

// 对应关系配置
export function config_list_node_user_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-node-user`,
    map,
    option
  ).then(response => response)
}

// 查询流程节点信息
export function config_list_process_name_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-process-name`,
    map,
    option
  ).then(response => response)
}

// 查询流程节点配置
export function config_list_process_node_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-process-node`,
    map,
    option
  ).then(response => response)
}

// 查询流程配置名称
export function config_list_process_node_name_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-process-node-name`,
    map,
    option
  ).then(response => response)
}

// 查询流程节点状态关系
export function config_list_process_node_relation_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-process-node-relation`,
    map,
    option
  ).then(response => response)
}

// 查询流程节点状态配置
export function config_list_process_node_state_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-process-node-state`,
    map,
    option
  ).then(response => response)
}

// 供应商小时工资列表
export function config_list_salary_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-salary`,
    map,
    option
  ).then(response => response)
}

// 查询供应商支付周期数据
export function config_list_supplier_cycle_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-supplier-cycle`,
    map,
    option
  ).then(response => response)
}

// 体型版型配置查询(分页)
export function config_page_config_plate_shape_attr_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/page-config-plate-shape-attr`,
    map,
    option
  ).then(response => response)
}

// 体型版型配置查询(分页)
export function config_page_config_plate_shape_attr_by_cp_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/page-config-plate-shape-attr-by-cp`,
    map,
    option
  ).then(response => response)
}

// 二维码
export function config_qr_code_url_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/qr-code-url`,
    map,
    option
  ).then(response => response)
}

// 查询按钮
export function config_query_menu_button_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/query-menu-button`,
    map,
    option
  ).then(response => response)
}

// 通过类目 tagId 获取商品亮点
export function config_query_product_highlights_by_tag_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/query-product-highlights-by-tag`,
    map,
    option
  ).then(response => response)
}

// renew流程节点信息
export function config_renew_process_name_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/renew-process-name`,
    map,
    option
  ).then(response => response)
}

// renew流程节点信息V2
export function config_renew_process_name_v2_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/renew-process-name-v2`,
    map,
    option
  ).then(response => response)
}

// 重置密码
export function config_reset_password_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/reset-password`,
    map,
    option
  ).then(response => response)
}

// 新增或编辑审版评语配置
export function config_spl_review_edit_config_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/spl-review/edit-config`,
    map,
    option
  ).then(response => response)
}

// 查询审版评语配置
export function config_spl_review_list_config_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/spl-review/list-config`,
    map,
    option
  ).then(response => response)
}

// 提交编辑新增供应商
export function config_submit_edit_add_supplier_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/submit-edit-add-supplier`,
    map,
    option
  ).then(response => response)
}

// 供应商编辑页面
export function config_supplier_edit_infos_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/supplier-edit-infos`,
    map,
    option
  ).then(response => response)
}

// 报关品类同步
export function config_sync_category_product_get(map, option) {
  return get(
    `${process.env.VUE_APP_CONFIG}/config/sync-category-product`,
    map,
    option
  ).then(response => response)
}

// 新增timeline流程配置
export function config_timeline_add_process_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/timeline/add-process`,
    map,
    option
  ).then(response => response)
}

// 新增timeline节点配置
export function config_timeline_add_process_node_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/timeline/add-process-node`,
    map,
    option
  ).then(response => response)
}

// 新增timeline流程节点关系配置
export function config_timeline_add_process_node_relation_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/timeline/add-process-node-relation`,
    map,
    option
  ).then(response => response)
}

// 新增timeline流程类目配置
export function config_timeline_add_work_bench_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/timeline/add-work-bench`,
    map,
    option
  ).then(response => response)
}

// timeline 报表 - 查询部门信息
export function config_timeline_business_group_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/timeline/business/group`,
    map,
    option
  ).then(response => response)
}

// timeline切换
export function config_timeline_change_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/timeline/change`,
    map,
    option
  ).then(response => response)
}

// 控件列表
export function config_timeline_control_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/timeline/control-list`,
    map,
    option
  ).then(response => response)
}

// 刪除timeline节点配置
export function config_timeline_delete_process_node_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/timeline/delete-process-node`,
    map,
    option
  ).then(response => response)
}

// 刪除timeline节点关系配置
export function config_timeline_delete_process_node_relation_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/timeline/delete-process-node-relation`,
    map,
    option
  ).then(response => response)
}

// 删除timeline流程类目配置
export function config_timeline_delete_work_bench_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/timeline/delete-work-bench`,
    map,
    option
  ).then(response => response)
}

// 导出统计报表
export function config_timeline_export_statement_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/timeline/export/statement`,
    map,
    option
  ).then(response => response)
}

// 导出产品明细报表
export function config_timeline_export_statement_detail_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/timeline/export/statement/detail`,
    map,
    option
  ).then(response => response)
}

// timeline 报表 - 导出 CP 明细表 - 节点
export function config_timeline_export_statement_nodecode_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/timeline/export/statement/nodecode`,
    map,
    option
  ).then(response => response)
}

// timeline 报表 - 导出 CP 明细表 - 总体数据
export function config_timeline_export_statement_overview_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/timeline/export/statement/overview`,
    map,
    option
  ).then(response => response)
}

// timeline 报表 - 页面跳转
export function config_timeline_export_statement_page_turns_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/timeline/export/statement/page/turns`,
    map,
    option
  ).then(response => response)
}

// 查询timeline流程配置
export function config_timeline_list_process_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/timeline/list-process`,
    map,
    option
  ).then(response => response)
}

// 查询timeline流程类目配置
export function config_timeline_list_work_bench_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/timeline/list-work-bench`,
    map,
    option
  ).then(response => response)
}

// 查询timeline节点配置
export function config_timeline_process_node_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/timeline/process-node`,
    map,
    option
  ).then(response => response)
}

// 查询timeline节点关系
export function config_timeline_process_node_relation_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/timeline/process-node-relation`,
    map,
    option
  ).then(response => response)
}

// timeline 报表 - 查询 timeline 统计表
export function config_timeline_statement_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/timeline/statement`,
    map,
    option
  ).then(response => response)
}

// timeline 报表 - 查询timeline产品明细报表
export function config_timeline_statement_detail_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/timeline/statement/detail`,
    map,
    option
  ).then(response => response)
}

// timeline 报表 - 总体数据
export function config_timeline_statement_overview_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/timeline/statement/overview`,
    map,
    option
  ).then(response => response)
}

// timeline 报表 - 根据模式查询 timeline 类型
export function config_timeline_type_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/timeline/type`,
    map,
    option
  ).then(response => response)
}

// 编辑采购员与供应商关联配置
export function config_update_config_purchaser_supplier_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/update-config-purchaser-supplier`,
    map,
    option
  ).then(response => response)
}

// 水洗符号与物料编码关联配置
export function config_update_config_symbol_ref_material_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/update-config-symbol-ref-material`,
    map,
    option
  ).then(response => response)
}

// 期望场次配置 更新
export function config_update_expected_sessions_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/update-expected-sessions`,
    map,
    option
  ).then(response => response)
}

// 更新动态菜单列
export function config_update_menu_field_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/update-menu-field`,
    map,
    option
  ).then(response => response)
}

// 对应关系配置
export function config_update_node_user_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/update-node-user`,
    map,
    option
  ).then(response => response)
}

// 对应关系更新状态
export function config_update_node_user_state_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/update-node-user-state`,
    map,
    option
  ).then(response => response)
}

// 核价配置 更新
export function config_update_pricing_supplier_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/update-pricing-supplier`,
    map,
    option
  ).then(response => response)
}

// 常备特殊面料 更新
export function config_update_standing_special_material_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/update-standing-special-material`,
    map,
    option
  ).then(response => response)
}

// 新增或者更新新增供应商账号
export function config_update_supplier_account_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/update-supplier-account`,
    map,
    option
  ).then(response => response)
}

// 上传流程节点明细
export function config_upload_process_node_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/upload-process-node`,
    map,
    option
  ).then(response => response)
}

// 外发打样异常类型配置
export function config_list_config_outsource_exception_type_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-outsource-exception-type`,
    map,
    option
  ).then(response => response)
}

// 新增外发打样异常类型配置
export function config_add_config_outsource_exception_type_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-config-outsource-exception-type`,
    map,
    option
  ).then(response => response)
}

// 编辑外发打样异常类型配置
export function config_edit_config_outsource_exception_type_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/edit-config-outsource-exception-type`,
    map,
    option
  ).then(response => response)
}

// 获取动态列值
export function config_list_column_cp_skc_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-column-cp-skc`,
    map,
    option
  ).then(response => response)
}

// 新增工艺员审版师配置
export function config_add_config_craftsman_ref_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-config-craftsman-ref`,
    map,
    option
  ).then(response => response)
}

// 删除工艺员审版师配置
export function config_delete_config_craftsman_ref_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/delete-config-craftsman-ref`,
    map,
    option
  ).then(response => response)
}

// 编辑工艺员审版师配置
export function config_edit_config_craftsman_ref_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/edit-config-craftsman-ref`,
    map,
    option
  ).then(response => response)
}

// 工艺员审版师配置
export function config_list_config_craftsman_ref_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-craftsman-ref`,
    map,
    option
  ).then(response => response)
}

// 功能性和特殊表才对应关系
export function config_list_config_function_special_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-function-special`,
    map,
    option
  ).then(response => response)
}

// 新增 PO PO 通知配置
export function config_add_config_popo_notify_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-config-popo-notify`,
    map,
    option
  ).then(response => response)
}

// 删除 PO PO 通知配置
export function config_delete_config_popo_notify_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/delete-config-popo-notify`,
    map,
    option
  ).then(response => response)
}

// 编辑 PO PO 通知配置
export function config_edit_config_popo_notify_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/edit-config-popo-notify`,
    map,
    option
  ).then(response => response)
}

// 查询 PO PO 通知配置
export function config_list_config_popo_notify_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-popo-notify`,
    map,
    option
  ).then(response => response)
}

// 查询 PO PO 通知配置
export function config_all_config_popo_notify_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/all-config-popo-notify`,
    map,
    option
  ).then(response => response)
}

// 批量删除 PO PO 通知配置
export function config_batch_delete_config_popo_notify_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/batch-delete-config-popo-notify`,
    map,
    option
  ).then(response => response)
}

// 批量启用/停用 PO PO 通知配置
export function config_batch_update_config_popo_notify_status_post(
  map,
  option
) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/batch-update-config-popo-notify-status`,
    map,
    option
  ).then(response => response)
}

// 删除 PO PO 通知配置-列内容
export function config_delete_config_popo_notify_content_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/delete-config-popo-notify-content`,
    map,
    option
  ).then(response => response)
}

// 根据流程id计算timeline计划结束时间
export function config_timeline_getTimeLineEndTime_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/timeline/getTimeLineEndTime`,
    map,
    option
  ).then(response => response)
}
